import { render } from "./ItemIndexCoupons.vue?vue&type=template&id=1788a235&scoped=true"
import script from "./ItemIndexCoupons.vue?vue&type=script&lang=js"
export * from "./ItemIndexCoupons.vue?vue&type=script&lang=js"

import "./ItemIndexCoupons.vue?vue&type=style&index=0&id=1788a235&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-1788a235"

export default script